
export default {
  init() {
    // Main slider
 
    // Product tabs functionality
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanels = document.querySelectorAll('.tab-panel');

    if (tabButtons.length > 0) {
      tabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const targetTab = button.getAttribute('data-tab');

          // Remove active class from all buttons and panels
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabPanels.forEach(panel => panel.classList.remove('active'));

          // Add active class to clicked button and corresponding panel
          button.classList.add('active');
          const targetPanel = document.getElementById(targetTab);
          if (targetPanel) {
            targetPanel.classList.add('active');
          }
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/single-bibp-produkty.js